import Vue from '../vue'
import Vuex from 'vuex'
import { setStorePrototypes } from '../libraries/vuePrototypes';

Vue.use(Vuex);

const sizeObj = {
  lg: 1264,
  md: 960,
  sm: 600,
  xs: 0,
};

const store = Vue.prototype.$store || new Vuex.Store({
  state: {
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight,
    modalConfirm: {
      show: false,
      title: null,
      message: null,
      okText: null,
      cancelText: null,
      hideCancel: false,
      optionMessage: null,
    },
    modalAlert: {
      show: false,
      title: null,
      message: null,
      okText: null,
    },
    token: null,
    user: null,
    spcoreMenuScrollPosition: 0,
    showSPCoreFilter: true,
    actics: {
      menuOpened: true,
      menuItems: null,
    },
    flags: null,
    rightClickEvent: {
      event: null,
      link: null,
    },
    isAppLoading: false,
    itm: {
      notificationCount: 0,
    },
  },
  getters: {
    state: (state) => state,
    get: (state) => (prop) => state[prop],
    set: (state) => (prop, value) => state[prop] = value,
    windowSize: (state) => (sizeMarkup) => state.windowWidth >= sizeObj[sizeMarkup],
    currentWindowSize: (state) => () => Object.keys(sizeObj).find(key => state.windowWidth >= sizeObj[key]),
  },
});

setStorePrototypes(store);
export default store;
